import { Avatar, Box, Stack, Tooltip, Typography } from "@mui/material";
import { StoreItemPreview } from "./StoreItemPreview";
import { StoreItem } from "types/vetcoin";
import { UserEquippedPet } from "types/user";
import { FC, ReactNode } from "react";
import { getLettersForUserName } from "utils/user";

export type UserWithPetProps = {
  pictureUrl?: string | null;
  name?: string | null;
  equippedStoreItems?: UserEquippedPet[] | null;
  avatarSize?: number;
  petSize?: number;
  /** When true, render the user name next to avatar/pet. */
  showName?: boolean;
  nameVariant?: "body1" | "body2" | "caption" | "subtitle1" | "subtitle2";
  subtitle?: ReactNode;
};

/** Avatar + optional VetPet (+ optional name) for any user. */
export const UserWithPet: FC<UserWithPetProps> = ({
  pictureUrl,
  name,
  equippedStoreItems,
  avatarSize = 40,
  petSize,
  showName = false,
  nameVariant = "body2",
  subtitle,
}) => {
  const displayName = name || "Unknown";
  const resolvedPetSize = petSize ?? Math.round(avatarSize * 0.7);
  const equippedPet = equippedStoreItems?.find(
    (item) => item.item_type === "PET",
  )?.store_item;

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1, minWidth: 0 }}>
      <Avatar
        src={pictureUrl ?? undefined}
        alt={displayName}
        sx={{ width: avatarSize, height: avatarSize, fontSize: avatarSize * 0.4 }}
      >
        {!pictureUrl ? getLettersForUserName(displayName) : null}
      </Avatar>
      {equippedPet && (
        <Tooltip title={`VetPet: ${equippedPet.name}`} arrow>
          <Box sx={{ width: resolvedPetSize, flexShrink: 0 }}>
            <StoreItemPreview
              item={equippedPet as unknown as StoreItem}
              size="small"
              chromeless
            />
          </Box>
        </Tooltip>
      )}
      {showName && (
        <Stack minWidth={0}>
          <Typography variant={nameVariant} noWrap fontWeight={500}>
            {displayName}
          </Typography>
          {subtitle}
        </Stack>
      )}
    </Box>
  );
};

/** @deprecated Prefer UserWithPet — kept for existing imports. */
export const CoachPetAvatar = UserWithPet;
